import React from "react";
import {Routes, Route, Navigate} from "react-router-dom";
import {Provider} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";
import CloneSensorsWatcher from "./components/CloneSensorsWatcher";
import Loader from "./components/Loader";
import Toaster from "./components/Toaster/Toaster";
import AppLayout from "./layouts/AppLayout";
import AuthLayout from "./layouts/AuthLayout";
import configureStore from "./redux/Store";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-phone-number-input/style.css";
import "react-toggle/style.css";
import "./assets/plugins/nucleo/scss/nucleo.scss";
import "./assets/scss/argon-dashboard-react.scss";
import "./assets/scss/react/_toggle.scss";
import "./default.scss";
import "./themes/test.theme.scss";

function App() {
  const storeObject = configureStore();
  const {store, persistor} = storeObject;
  return (
    <Provider store={store}>
      <Toaster />
      <PersistGate loading={null} persistor={persistor}>
        <CloneSensorsWatcher />
        <Routes>
          <Route path="auth/*" element={<AuthLayout />} />
          <Route path="app/*" element={<AppLayout />} />
          <Route path="/" element={<Navigate to="auth/*" />} />
          <Route path="*" replace element={<Navigate to="/auth/login" />} />
        </Routes>
      </PersistGate>
      <Loader />
    </Provider>
  );
}
export default App;
